import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as services from "../../store/service";
import { isIDFPartnerUser } from "../../util/partner";
import { DialogComponent } from "../common/DialogComponent";
import CCAMConfirmationDialog from "../Dialogs/CCAMConfirmationDialog";

const CCAMEnroll = (props: any) => {
    const dispatch = useDispatch();
    const termsOfUseLegalDocumentLabel: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.termsOfUseLegalDocumentLabel
            ? state.configurationState.configuration.partnerConfig.termsOfUseLegalDocumentLabel
            : "Terms of Use"
    );
    const termsOfUseLegalDocumentLink: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.termsOfUseLegalDocumentLink
            ? state.configurationState.configuration.partnerConfig.termsOfUseLegalDocumentLink
            : ""
    );
    const isIDFPartner = useSelector((state: ApplicationState) =>
        state.configurationState &&
        state.configurationState.configuration.partnerConfig.partnerId &&
        state.configurationState.configuration.partnerConfig.isIdfPartner
            ? !isIDFPartnerUser(state.configurationState.configuration.partnerConfig.partnerId)
            : false
    );
    const privacyPolicyLegalDocumentLink: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.privacyPolicyLegalDocumentLink
            ? state.configurationState.configuration.partnerConfig.privacyPolicyLegalDocumentLink
            : ""
    );
    const privacyPolicyLegalDocumentLabel: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.privacyPolicyLegalDocumentLabel
            ? state.configurationState.configuration.partnerConfig.privacyPolicyLegalDocumentLabel
            : "Privacy Policy"
    );
    const enrolledChildrenList = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userInfo?.childrenList ? state.loggedInUser.userInfo?.childrenList : []
    );
    const activeAccount = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.activeAccount ? state.loggedInUser.activeAccount : {}
    );
    const alerts: any = useSelector((state: ApplicationState) => (state.alertState && state.alertState.alertData ? state.alertState.alertData : []));
    const subscriptionEndedAlert = alerts.filter((alert: any) => (alert["serviceType"] === "SubscriptionEnded"));
    const failedChildrenList = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userInfo?.failedChildrenList ? state.loggedInUser.userInfo?.failedChildrenList : []
    );
    const loggedInActiveAccountID = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.activeAccount ? state.loggedInUser.activeAccount.subcustomerId : null
    );
    const legalDocUpdate = useSelector((state: ApplicationState) => {
        if (state.configurationState && state.configurationState.configuration && state.configurationState.configuration.partnerConfig) {
            return {
                termsAndConditionUpdated: state.configurationState.configuration.partnerConfig.termsAndCondtionsUpdated,
                privacyPolicyUpdated: state.configurationState.configuration.partnerConfig.privacyPolicyUpdated,
            };
        }
        return { termsAndConditionUpdated: false, privacyPolicyUpdated: false };
    });
    const [activityDetected, setActivityDetected] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [errorResponse, setErrorResponse]: any = useState({});
    const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
    const [childEnrollStatus, setChildEnrollStatus]: any = useState({});
    const [state, setState] = useState({
        firstName: "",
        lastName: "",
        dob: "",
        SSN: "",
        confirmSSN: "",
        ssn1: "",
        ssn2: "",
        ssn3: "",
        cssn1: "",
        cssn2: "",
        cssn3: "",
        confirmSNNError: false,
        userId: "",
    });

    const { register, handleSubmit, errors } = useForm({
        mode: "onSubmit",
        reValidateMode: "onChange",
    });

    const openTermsOfUsePage = () => {
        const base_url = decodeURIComponent(encodeURIComponent(window.location.origin)) + "/app";
        if (isIDFPartner) {
            const urlToOpen = "https://www.sontiq.com/terms-of-use/";
            return urlToOpen;
        }

        if (termsOfUseLegalDocumentLink) {
            const urlToOpen = termsOfUseLegalDocumentLink.startsWith("/") ? base_url + termsOfUseLegalDocumentLink : termsOfUseLegalDocumentLink;
            return urlToOpen;
        }
        return base_url + "/terms";
    };

    const openPrivacyPolicyPage = () => {
        const base_url = decodeURIComponent(encodeURIComponent(window.location.origin)) + "/app";
        if (isIDFPartner) {
            const urlToOpen = "https://www.sontiq.com/privacy-policy/";
            return urlToOpen;
        }

        if (privacyPolicyLegalDocumentLink) {
            const urlToOpen = privacyPolicyLegalDocumentLink.startsWith("/") ? base_url + privacyPolicyLegalDocumentLink : privacyPolicyLegalDocumentLink;
            return urlToOpen;
        }

        return base_url + "/privacy";
    };

    const handleSSN1 = (event: any) => {
        const ssn1 = event.target.value;
        const SSN = ssn1 + state.ssn2 + state.ssn3;
        const confirmSNNError = state.confirmSSN && state.confirmSSN !== SSN ? true : false;

        setState({
            ...state,
            ssn1,
            SSN,
            confirmSNNError,
        });

        if (ssn1.length > 2) {
            document.getElementById("ssn2")?.focus();
        }
    };

    const handleSSN2 = (event: any) => {
        const ssn2 = event.target.value;
        const SSN = state.ssn1 + ssn2 + state.ssn3;
        const confirmSNNError = state.confirmSSN && state.confirmSSN !== SSN ? true : false;

        setState({
            ...state,
            ssn2,
            SSN,
            confirmSNNError,
        });

        if (ssn2.length > 1) {
            document.getElementById("ssn3")?.focus();
        }
    };

    const handleSSN3 = (event: any) => {
        const ssn3 = event.target.value;
        const SSN = state.ssn1 + state.ssn2 + ssn3;
        const confirmSNNError = state.confirmSSN && state.confirmSSN !== SSN ? true : false;

        setState({
            ...state,
            ssn3,
            SSN,
            confirmSNNError,
        });

        if (ssn3.length > 3) {
            document.getElementById("cssn1")?.focus();
        }
    };

    const handleCSSN1 = (event: any) => {
        const cssn1 = event.target.value;
        const confirmSSN = cssn1 + state.cssn2 + state.cssn3;
        const confirmSNNError = confirmSSN !== state.SSN ? true : false;

        setState({
            ...state,
            cssn1,
            confirmSSN,
            confirmSNNError,
        });

        if (cssn1.length > 2) {
            document.getElementById("cssn2")?.focus();
        }
    };

    const handleCSSN2 = (event: any) => {
        const cssn2 = event.target.value;
        const confirmSSN = state.cssn1 + cssn2 + state.cssn3;
        const confirmSNNError = confirmSSN !== state.SSN ? true : false;

        setState({
            ...state,
            cssn2,
            confirmSSN,
            confirmSNNError,
        });

        if (cssn2.length > 1) {
            document.getElementById("cssn3")?.focus();
        }
    };

    const handleCSSN3 = (event: any) => {
        const cssn3 = event.target.value;
        const confirmSSN = state.cssn1 + state.cssn2 + cssn3;
        const confirmSNNError = confirmSSN !== state.SSN ? true : false;

        setState({
            ...state,
            cssn3,
            confirmSSN,
            confirmSNNError,
        });
    };

    const checkCreditAlert = () => {
        const creditActivityAlerts = alerts.filter((alert: any) => 
        (alert["serviceType"] === "CreditActivityAlert" ||
         alert["serviceType"] === "ChildCreditActivityMonitoring" ||
         alert["serviceType"] === "SubscriptionEnded"));
        setActivityDetected(creditActivityAlerts.length > 0);
        if (creditActivityAlerts.length > 0) {
            props.updateActivityDetected();
        }
    };

    useEffect(() => {
        setIsLoading(true);

        services
            .getMonitoring()
            .then((getMonitoringResponse) => {
                if (getMonitoringResponse?.asset?.personalInformation["date-of-birth"]) {
                    const userId = getMonitoringResponse["user-id"];
                    const personalInformation = getMonitoringResponse?.asset?.personalInformation;
                    if (personalInformation && personalInformation["first-name"]) {
                        setState({
                            ...state,
                            firstName: personalInformation["first-name"],
                            lastName: personalInformation["last-name"],
                            dob: personalInformation["date-of-birth"],
                            userId: userId,
                        });
                    }
                }
                checkChildStatus();
                setIsLoading(false);
            })
            .catch(function (error) {
                setIsLoading(false);
            });
        checkCreditAlert();
    }, []);

    const checkChildStatus = () => {
        const childEnrolled = enrolledChildrenList.find((child: any) => child.subAccountPk === activeAccount.subcustomerId);
          setChildEnrollStatus(childEnrolled);
      };

   
    const scrollToFAQ = () => {
        document.getElementById("freeze-FAQ")?.scrollIntoView({
            behavior: "auto",
            block: "center",
            inline: "center",
        });
    };
    const SubmitCCAMEnroll = (data: any) => {
        const requestBody = {
            FullName: {
                FirstName: state.firstName,
                LastName: state.lastName,
            },
            DateOfBirth: state.dob,
            Ssn: state.SSN,
        };
        setIsLoading(true);
        services
            .enrollCCAM(requestBody)
            .then((response) => {
                if (response["statusCode"] === 200) {
                    // sontiq and idf API's have different structures, hence the  or condition
                    if (
                        (response["data"][0] && response["data"][0]["child"]) ||
                        (isIDFPartner &&
                            response["data"][0] &&
                            response["data"][0]["enrollmentStatusReason"] &&
                            response["data"][0]["enrollmentStatusReason"].includes("21"))
                    ) {
                        const enrolledChildData = {
                            enrollmentStatusReason: isIDFPartner ? response["data"][0].enrollmentStatusReason : response["data"][0]["child"].enrollmentStatusReason,
                            subAccountPk: activeAccount.subcustomerId,
                            unenrollmentStatusReason: isIDFPartner
                                ? response["data"][0].unenrollmentStatusReason
                                : response["data"][0]["child"].unenrollmentStatusReason,
                            errorMessage: null,
                        };
                        setChildEnrollStatus(enrolledChildData);
                        const filteredChildrenList = enrolledChildrenList.filter((child: any) => child.subAccountPk !== activeAccount.subcustomerId);
                        const newEnrolledChildList = [...filteredChildrenList, enrolledChildData];
                        dispatch({ type: "SET_SUCCESSFUL_ENROLLED_CHILD_LIST", childrenList: newEnrolledChildList });
                        dispatch({ type: "SET_MONITORED_CHILD_COUNT", numChildrenMonitored: response.data[0].numChildrenMonitored });
                        setIsSuccess(true);
                        services
                            .sendEmailNotification({
                                alertType: "CCAM_GOOD_NEWS",
                                callerSource: "CGW",
                                gatewayCampaignName: "CCAM_GOOD_NEWS",
                            })
                            .then((data) => {});
                    } else {
                        if (response["data"][0]["errorResponse"].name === "CCAM_CHILDREN_LIMIT_EXCEEDED") {
                            const failedChildList = [...failedChildrenList, { id: loggedInActiveAccountID }];
                            dispatch({ type: "SET_FAILED_ENROLLED_CHILD_LIST", failedChildrenList: failedChildList });
                        }
                        const enrolledChildData = {
                            enrollmentStatusReason: null,
                            subAccountPk: activeAccount.subcustomerId,
                            unenrollmentStatusReason: null,
                            errorMessage: response["data"][0]["errorResponse"] ? response["data"][0]["errorResponse"].code : null,
                        };
                        setChildEnrollStatus(enrolledChildData);
                        const filteredChildrenList = enrolledChildrenList.filter((child: any) => child.subAccountPk !== activeAccount.subcustomerId);
                        const newEnrolledChildList = [...filteredChildrenList, enrolledChildData];
                        dispatch({ type: "SET_SUCCESSFUL_ENROLLED_CHILD_LIST", childrenList: newEnrolledChildList });
                        setIsSuccess(false);
                        setErrorResponse(response["data"][0]["errorResponse"]);
                    }
                } else {
                    setIsSuccess(false);
                }
                setShowConfirmationDialog(true);
                setIsLoading(false);
            })
            .catch(() => {
                setIsSuccess(false);
                setShowConfirmationDialog(true);
                setIsLoading(false);
            });
    };

    const closeConfirmationDialog = (): any => {
        setShowConfirmationDialog(false);

        if (props.validateChildCount !== null) {
            props.validateChildCount(true);
        }
    };

    return (
        <React.Fragment>
            
            {subscriptionEndedAlert && subscriptionEndedAlert.length > 0  ?                           
                <div className="data-grid" role="grid" style={{ backgroundColor: "#F2F6F9", width: "100%", padding: "10px" }}>
                    <div className="box-header col-xs-12 col-sm-12 ">
                        <div className="content-sub-title text-align-center">
                            <div className="monitoring-alert-icon" style={{ fontSize: "40px" }}>
                                <em className="las la-exclamation-circle "></em>
                            </div>
                        </div>
                    </div>
                    <div className="box-content text-align-center margin-bottom-s">
                     <p> Your child/dependent was unenrolled from TransUnion Child Credit Monitoring because they turned 18.</p>
                    </div>
                </div> :
            <div className="data-grid" role="grid">
                <div className={`box-content margin-bottom-s ${isLoading ? " loading" : ""}`}>
                     <div className="box-header">
                       <div className="box-title-container">
                         <div className="box-title-text">
                            <div className="text-primary-deep margin-bottom-sx">
                               <strong>{state.firstName + " " + state.lastName}</strong>
                                </div>
                                    {
                                    <div className="text-primary-deep">
                                        <strong>
                                            <small>
                                                {activityDetected ||
                                                !!(childEnrollStatus && childEnrollStatus["subAccountPk"] && !!!childEnrollStatus["errorMessage"])
                                                    ? `Last Scan: ${new Date().getMonth() + 1}/${new Date().getDate()}/${new Date().getFullYear()}`
                                                    : `${state.dob ? state.dob.substr(0, state.dob.length - 4) + "XXXX" : ""}`}
                                            </small>
                                        </strong>
                                    </div>
                                }
                            </div>
                        </div>
                    {!!(childEnrollStatus && childEnrollStatus["subAccountPk"] && !!!childEnrollStatus.errorMessage) && (
                            <div className="box-actions text-primary-deep">
                                <span className={`pill-tag ${!activityDetected ? " all-clear" : ""}`}>{activityDetected ? "Activity Detected" : "All Clear"}</span>
                            </div>
                    )}
                    </div> 
                    {!!childEnrollStatus && !!childEnrollStatus?.errorMessage && childEnrollStatus?.errorMessage.includes("551") && (
                        <p>
                            This child/dependent cannot be enrolled in Child Credit Activity Monitoring, since you have already reached the limit of only 4 parents
                            monitoring the same child.
                        </p>
                    )}
                    {!!childEnrollStatus && !!childEnrollStatus?.errorMessage && childEnrollStatus?.errorMessage.includes("102056") && (
                        <p>Child must be less than 18 years old for Child Credit Activity Monitoring.</p>
                    )}
                    {(!!(childEnrollStatus && childEnrollStatus["subAccountPk"]) || activityDetected) && !!!childEnrollStatus.errorMessage && (
                        <div>
                            {activityDetected ? (
                                <p>
                                    A credit file does exist at TransUnion with your child's/dependent's SSN. If you suspect that this may be or indicates a
                                    fraudulent use of your child's/dependent's identity, see the Protected Consumer{" "}
                                    <a
                                        href="#"
                                        className="default_link"
                                        onClick={(e: any) => {
                                            e.preventDefault();
                                            scrollToFAQ();
                                        }}
                                    >
                                        Freeze steps
                                    </a>{" "}
                                    to learn how you can help protect their credit file. Or, if your child/dependent is 16 or 17, see the{" "}
                                    <a
                                        href="#"
                                        className="default_link"
                                        onClick={(e: any) => {
                                            e.preventDefault();
                                            scrollToFAQ();
                                        }}
                                    >
                                        Freeze steps
                                    </a>{" "}
                                    that they will need to follow. Keep in mind that both types of Freezes are offline processes with initial and closing
                                    communication by mail. We also recommend that you contact the other Consumer Reporting Agencies as information can vary.
                                </p>
                            ) : (
                                <p>
                                    Good news! A credit file does not exist at TransUnion with your child's/dependent's SSN. Our ongoing monitoring product will
                                    alert you of future activity.
                                </p>
                            )}
                        </div>
                    )} 
                    {!isSuccess &&
                        (childEnrollStatus && childEnrollStatus["subAccountPk"]
                            ? !!childEnrollStatus.errorMessage
                                ? !(childEnrollStatus?.errorMessage.includes("551") || childEnrollStatus?.errorMessage.includes("102056"))
                                : false
                            : true) &&
                        !activityDetected && (
                            <div>
                                <form id="ccam-enroll" onSubmit={handleSubmit(SubmitCCAMEnroll)}>
                                    <div className="margin-bottom-m margin-top-s">
                                        <div className={`form-row inline row`}>
                                            <div className="form-label col-xs-12 col-sm-6 col-no-gutter">
                                                <label htmlFor="label-address-zipcode">
                                                    Social Security #{" "}
                                                    <span className="required" title="Mandatory">
                                                        *
                                                    </span>
                                                </label>
                                            </div>
                                            <div className="form-input col-xs-12 col-sm-6 col-no-gutter">
                                                <div className="row">
                                                    <div className="form-input row">
                                                        <div className={`col-xs-4 col-no-gutter ${errors["ssn1"] && "status-error"}`}>
                                                            <input
                                                                type="password"
                                                                maxLength={3}
                                                                className="inputbox"
                                                                autoComplete="off"
                                                                defaultValue={state.ssn1}
                                                                onChange={handleSSN1}
                                                                name="ssn1"
                                                                id="ssn1"
                                                                ref={register({ pattern: /[\d]{3}/, required: true })}
                                                            />
                                                        </div>
                                                        <div className={`col-xs-3 col-gutter-horizontal ${errors["ssn2"] && "status-error"}`}>
                                                            <input
                                                                type="password"
                                                                maxLength={2}
                                                                className="inputbox"
                                                                autoComplete="off"
                                                                defaultValue={state.ssn2}
                                                                onChange={handleSSN2}
                                                                name="ssn2"
                                                                id="ssn2"
                                                                ref={register({ pattern: /[\d]{2}/, required: true })}
                                                            />
                                                        </div>
                                                        <div className={`col-xs-5 col-no-gutter ${errors["ssn3"] && "status-error"}`}>
                                                            <input
                                                                type="password"
                                                                maxLength={4}
                                                                className="inputbox"
                                                                autoComplete="off"
                                                                defaultValue={state.ssn3}
                                                                onChange={handleSSN3}
                                                                name="ssn3"
                                                                id="ssn3"
                                                                ref={register({ pattern: /[\d]{4}/, required: true })}
                                                            />
                                                        </div>
                                                        {(errors["ssn1"] || errors["ssn2"] || errors["ssn3"]) && (
                                                            <span className="form-error">Please enter valid Social Security Number.</span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            className={`form-row inline row ${
                                                (state.confirmSNNError || errors["cssn1"] || errors["cssn2"] || errors["cssn3"]) && "status-error"
                                            }`}
                                        >
                                            <div className="form-label col-xs-12 col-sm-6 col-no-gutter">
                                                <label htmlFor="label-address-zipcode">
                                                    Confirm Social Security #{" "}
                                                    <span className="required" title="Mandatory">
                                                        *
                                                    </span>
                                                </label>
                                            </div>
                                            <div className="form-input col-xs-12 col-sm-6 col-no-gutter">
                                                <div className="row">
                                                    <div className="form-input row">
                                                        <div className="col-xs-4 col-no-gutter">
                                                            <input
                                                                type="password"
                                                                maxLength={3}
                                                                className="inputbox"
                                                                autoComplete="off"
                                                                defaultValue={state.cssn1}
                                                                onChange={handleCSSN1}
                                                                name="cssn1"
                                                                id="cssn1"
                                                                ref={register({ pattern: /[\d]{3}/, required: true })}
                                                            />
                                                        </div>
                                                        <div className="col-xs-3 col-gutter-horizontal">
                                                            <input
                                                                type="password"
                                                                maxLength={2}
                                                                className="inputbox"
                                                                autoComplete="off"
                                                                defaultValue={state.cssn2}
                                                                onChange={handleCSSN2}
                                                                name="cssn2"
                                                                id="cssn2"
                                                                ref={register({ pattern: /[\d]{2}/, required: true })}
                                                            />
                                                        </div>
                                                        <div className="col-xs-5 col-no-gutter">
                                                            <input
                                                                type="password"
                                                                maxLength={4}
                                                                className="inputbox"
                                                                autoComplete="off"
                                                                defaultValue={state.cssn3}
                                                                onChange={handleCSSN3}
                                                                name="cssn3"
                                                                id="cssn3"
                                                                ref={register({ pattern: /[\d]{4}/, required: true })}
                                                            />
                                                        </div>
                                                    </div>
                                                    {(errors["cssn1"] || errors["cssn2"] || errors["cssn3"]) && (
                                                        <span className="form-error">Please enter valid Confirm Social Security Number.</span>
                                                    )}
                                                    {!(errors["cssn1"] || errors["cssn2"] || errors["cssn3"]) && state.confirmSNNError && (
                                                        <span className="form-error">Your Social Security Numbers do not match.</span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <p>
                                            By checking this box and submitting my child's/dependent's enrollment information, I am attesting and certifying that I
                                            am the parent/guardian of this child/dependent, that I have the lawful right to provide this information, and that my
                                            child/dependent is under 18 years of age. I certify that I will only use the information obtained by this monitoring
                                            product for the sole purpose of taking steps to protect my child's/dependent's identity.
                                        </p>
                                        <p></p>
                                        <p>
                                            I understand and agree that this monitoring product uses TransUnion credit report transactions associated with my
                                            child's/dependent's personal information to provide credit activity alerts for the purpose of identity protection. I
                                            understand and agree that access to and/or use of additional alert details or further protective functions beyond any
                                            credit activity alert(s) triggered by this product require proof of guardianship prior to TransUnion releasing any
                                            additional information to me.
                                        </p>
                                    </div>
                                    <div className="form-row margin-top-s">
                                        <div className="form-input">
                                        <label className="form-checkbox-label" htmlFor="isTermsChecked">
                                                <input
                                                    type="checkbox"
                                                name="isTermsChecked"
                                                id="isTermsChecked"
                                                    ref={register({ required: true })}
                                                    onClick={() => {
                                                        window.addToDataLayer({ event: "Clicked on I agree checkbox" });
                                                    }}
                                                />
                                                <div className="form-checkbox-label-text form-checkbox-inline" style={{ lineHeight: "1.5rem" }}>
                                                    Yes, I agree to and acknowledge the above and provide this instruction to add my child/dependent to the Child
                                                    Credit Activity Monitoring product. I also have read and agree to the{" "}
                                                    <a
                                                        href={openTermsOfUsePage()}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        onClick={() => {
                                                            window.addToDataLayer({ event: "Terms of Use" });
                                                        }}
                                                    >
                                                        <span className="nav-text">{termsOfUseLegalDocumentLabel}</span>
                                                        {legalDocUpdate.termsAndConditionUpdated}
                                                    </a>{" "}
                                                    and{" "}
                                                    <a
                                                        href={openPrivacyPolicyPage()}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        onClick={() => {
                                                            window.addToDataLayer({ event: "Privacy Policy" });
                                                        }}
                                                    >
                                                        <span className="nav-text">{isIDFPartner ? "Privacy Notice" : privacyPolicyLegalDocumentLabel}</span>
                                                        {legalDocUpdate.privacyPolicyUpdated}
                                                    </a>
                                                    .
                                                </div>
                                            </label>
                                            {errors["isTermsChecked"] && errors["isTermsChecked"].type === "required" && (
                                                <span className="form-error">You must agree the Terms of Use and Privacy Policy to continue.</span>
                                            )}
                                        </div>
                                    </div>
                                    <div className="row between-xs margin-top-m">
                                        <div className="col-xs col-no-gutter flex-grow-null"></div>
                                        <div className="col-xs col-no-gutter flex-grow-null">
                                            <ul className="list-inline list-reset">
                                                <li className="margin-left-s">
                                                    <button type="submit" className="btn-default btn-primary btn-min-width">
                                                        <span className="btn-text">Submit</span>
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        )}
                </div>
            </div>
}

            {showConfirmationDialog && (
                <DialogComponent dialogId="dialog-ccam-enroll-confirmation" title="CCAM Enrollment Confirmation" closeDialog={closeConfirmationDialog}>
                    <CCAMConfirmationDialog closeDialog={closeConfirmationDialog} isSuccess={isSuccess} errorResponse={errorResponse} />
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default CCAMEnroll;
